/**
 * @generated SignedSource<<2697a6a2f004f5967f08023d9b66b064>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemHeartWrapper_viewer" | "ItemTile_viewer">;
  readonly " $fragmentType": "CarouselItemTile_viewer";
};
export type CarouselItemTile_viewer$key = {
  readonly " $data"?: CarouselItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTile_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "fetchFavorites"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "64e3d74f59663e137dc8254f28856168";

export default node;
